export const NotificationConstants = {
  NoDeletePermissionForDocument: 'You don\'t have permission to delete documents of this file type',
  NoEmailPermissionForDocument: 'You don\'t have permission to email documents of this file type',
  CannotDeleteDocumentLinkedToWorkflow: 'Document cannot be deleted as it\'s linked to a workflow job',
  NoDeletePermissionForPage: 'You don\'t have permission to delete document pages of this file type',
  NoExportPermissionForDocument: 'You don\'t have permission to export documents of this file type',
  OnlyMultiPageTifsSupportPageDeletion: 'Only multi-page TIF documents support page deletion',
  DocumentCannotBeDeletedUnlessItsBeingViewed: 'Document cannot be deleted unless it\'s being viewed',
  CannotDeleteDocumentPagesFromOlderVersions: 'Pages cannot be deleted from older versions of the document',
  UnknownError: 'Sorry an unknown error has occurred',
  UploadToDocumentTypeNotAllowed: 'Unable to upload to this document type because it has mandatory references',
  WorkflowDocumentPlaceHolderText:
  'There is no primary document for this workflow job.  If you select Related Documents, they will be displayed here.', 
  CannotEditDocumentLinkedToUpdatedWorkflowJob: 
  'Unable to edit document references because the workflow job has been changed'
};